import { render, staticRenderFns } from "./dhd_service.vue?vue&type=template&id=f2c06c82&scoped=true"
import script from "./dhd_service.vue?vue&type=script&lang=js"
export * from "./dhd_service.vue?vue&type=script&lang=js"
import style0 from "./dhd_service.vue?vue&type=style&index=0&id=f2c06c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c06c82",
  null
  
)

export default component.exports